/**
 * Client-safe constants shared by the site's native forms and their server
 * actions. Kept out of "use server" modules, which may only export async
 * functions.
 */

export type FormState =
  | { status: "idle" }
  | { status: "success" }
  | { status: "error"; message: string };

export const GENERIC_FORM_ERROR = "Something went wrong. Please try again in a moment.";

// reCAPTCHA v3 action names. The server checks the token was minted for the
// matching action so a token from one form cannot be replayed on another.
export const NEWSLETTER_RECAPTCHA_ACTION = "newsletter_signup";
export const CONTACT_RECAPTCHA_ACTION = "contact_message";

// Mirrors the "Subject" enumeration on the HubSpot contact form. Values are
// sent verbatim, so they must match HubSpot's option values exactly.
export const CONTACT_REASONS = [
  "Request A Quote",
  "General Inquiry",
  "Billing & Invoicing",
  "Technical Support",
  "Feedback",
  "Other",
] as const;
export type ContactReason = (typeof CONTACT_REASONS)[number];

// Consent wording copied from the HubSpot contact form definition. HubSpot
// records the exact text shown, so the UI and the action share one source.
export const CONTACT_COMMUNICATION_CONSENT_TEXT =
  "I agree to receive communications from CloudBreach.";
export const CONTACT_PROCESSING_CONSENT_TEXT =
  "By clicking submit below, you consent to allow CloudBreach to store and process the personal information submitted above to provide you the content requested.";

// Shared Tailwind class strings so every native form renders identically.
// text-base keeps inputs at 16px, which stops iOS zooming on focus.
export const inputClass =
  "w-full rounded-lg border border-cb-border bg-cb-surface-2 px-4 py-3 text-base text-cb-text placeholder:text-cb-muted-2 outline-none focus:border-cb-violet focus:ring-2 focus:ring-cb-violet/15 transition-colors";

export const labelClass = "block text-xs font-semibold text-cb-muted uppercase tracking-widest mb-2";

export const submitButtonClass =
  "inline-flex min-h-11 w-full sm:w-auto items-center justify-center gap-2 rounded-md bg-cb-violet px-6 py-3 text-sm font-medium text-white transition-all duration-150 hover:bg-cb-violet-dim active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cb-violet/50 disabled:opacity-50 disabled:pointer-events-none cursor-pointer";
